require("./index.marko.scss");
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            currentIndex: 0,
            focusPosition: 'right',
            attributes: [],
            backEdit: false,
            standby: false,
            showPosterPlus: false,
            selectedFiles: null
        };
        GState.bind(this, [
            'user',
            'screen'
        ]);
    },
    onMount: function () {
        const options = {
            centeredSlides: false,
            slidesPerView: ![
                'xs',
                'sm'
            ].includes(this.state.screen.media) ? 2 : 1,
            spaceBetween: 30,
            allowTouchMove: false
        };
        Swiper.use([
            Navigation,
            Pagination
        ]);
        this.swiper = new Swiper(this.getEl('swiper-container'), options);
    },
    onSelectFile: function (status) {
        this.state.showPosterPlus = status || false;
    },
    onPushFiles: function (files) {
        if (Array.isArray(files)) {
            if (!files.length)
                return;
            this.state.showPosterPlus = false;
            this.state.selectedFiles = files;
            return;
        }
        const {base64, src} = files;
        if (!src)
            return;
        this.state.showPosterPlus = false;
        this.state.selectedFiles = base64 || src;
    },
    onPrev: function (index, e) {
        const Step = Manifests[index];
        if (!Step)
            return;
        const {attribute, actions} = Step;
        actions.prev && this.navigate(index - 1, true);
        this.state.backEdit = true;
    },
    onNext: function (index, data, e) {
        const Step = Manifests[index];
        if (!Step)
            return;
        const {attribute, actions} = Step;
        if (data && attribute) {
            !window.uiStore.get(attribute) ? window.uiStore.set(attribute, data) : window.uiStore.update(attribute, data, 'add');
            if (!this.state.attributes.includes(attribute))
                this.state.attributes.push(attribute);
        }
        actions.next && this.navigate(index + 1);
        (actions.submit || actions.edit) && this.onSubmit(actions);
        this.state.backEdit = false;
    },
    onDone: async function () {
        this.state.standby = true;
        const domain = window.uiStore.get('setup-institution').subdomain + '.' + window.location.host.replace(window.Defaults.domainAddon + '.', '');
        if (await this.isDomainActive(domain)) {
            this.state.standby = false;
            document.location = '//' + domain;
        }
        window.uiStore.clear(this.state.attributes);
    },
    onSubmit: async function (actions) {
        try {
            let URI, method, data;
            if (this.state.backEdit && actions.edit) {
                URI = actions.edit.URI;
                method = actions.edit.method;
                data = window.uiStore.get(actions.edit.attribute);
            } else if (actions.submit) {
                URI = actions.submit.URI;
                method = actions.submit.method;
                data = actions.submit.attribute ? window.uiStore.get(actions.submit.attribute) : actions.submit.data || {};
            }
            if (!URI || !data)
                return;
            const response = await Request(URI, method, data);
        } catch (error) {
            console.error(error);
        }
    },
    navigate: function (goTo, back) {
        if ([
                'xs',
                'sm'
            ].includes(this.state.screen.media))
            this.swiper.slideTo(goTo);
        else {
            if (goTo > 0 && goTo >= this.state.currentIndex && this.state.focusPosition == 'right')
                this.state.focusPosition = 'left';
            else if (goTo < this.state.currentIndex && this.state.focusPosition == 'left')
                this.state.focusPosition = 'right';
            else
                this.swiper.slideTo(back ? goTo : goTo - 1);
        }
        this.state.currentIndex = goTo;
    },
    isDomainActive: function (domain) {
        return new Promise(resolve => {
            $.get('/lookup?hostname=' + domain).done(response => resolve(true)).fail(error => setTimeout(async () => await this.isDomainActive(domain), 15000));
        });
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Onboarding/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_Swiper = require("swiper"),
    Swiper = module_Swiper.default || module_Swiper,
    Navigation = module_Swiper.Navigation,
    Pagination = module_Swiper.Pagination,
    module_BackgroundImg = require("~/../public/images/backgrounds/c1.png"),
    BackgroundImg = module_BackgroundImg.default || module_BackgroundImg,
    module_Manifests = require("~/../manifests/ONBOARDING.json"),
    Manifests = module_Manifests.default || module_Manifests,
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag"),
    Preloader_template = require("../../../components/Preloader/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Preloader_tag = marko_loadTag(Preloader_template),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    PosterPlus_template = require("../../../components/PosterPlus/index.marko"),
    PosterPlus_tag = marko_loadTag(PosterPlus_template),
    marko_attrs0 = {
        "class": "position-relative w-100 theme-bg"
      },
    marko_attrs1 = {
        "class": "swiper-container"
      },
    marko_attrs2 = {
        "class": "swiper-wrapper"
      },
    marko_attrs3 = {
        "class": "h-100 d-flex align-items-center"
      },
    marko_attrs4 = {
        "class": "swiper-slide position-relative vh-100 p-3"
      },
    marko_attrs5 = {
        "class": "w-100 text-center px-3"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("06f06d"),
    marko_node0 = marko_createElement("br", null, "7", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "8", null, 0, 0, {
        i: marko_const_nextId()
      });

require("swiper/swiper-bundle.css");

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  out.be("div", marko_attrs1, "@swiper-container", component);

  out.be("div", marko_attrs2, "1", component);

  marko_forOf(Manifests, function(each, key) {
    var $keyValue$0 = "@" + key,
        $keyScope$0 = "[" + ($keyValue$0 + "]");

    out.be("div", marko_attrs4, $keyValue$0, component);

    marko_dynamicTag(out, require("./components/" + each.component), function() {
      return marko_assign({
          index: key,
          reset: state.standby,
          selectedFiles: state.selectedFiles
        }, each);
    }, null, null, null, __component, "2" + $keyScope$0, [
      [
        "next",
        "onNext",
        false
      ],
      [
        "prev",
        "onPrev",
        false
      ],
      [
        "edit",
        "onEdit",
        false
      ],
      [
        "done",
        "onDone",
        false
      ],
      [
        "select-file",
        "onSelectFile",
        false
      ]
    ]);

    out.ee();
  });

  out.ee();

  out.ee();

  out.be("div", {
      id: "out-overlay",
      "class": marko_classValue((((("theme-bg-transparent focus-" + state.focusPosition) + " ") + (state.standby ? "standby" : "")) + " ") + ((!state.standby) && [
          "xs",
          "sm"
        ].includes(state.screen.media) ? "d-none" : ""))
    }, "3", component, null, 1);

  out.be("div", marko_attrs3, "4", component);

  if (state.standby) {
    out.be("div", marko_attrs5, "5", component);

    Preloader_tag({
        class: "font-large-5 text-primary",
        active: true
      }, out, __component, "6");

    out.n(marko_node0, component);

    out.n(marko_node1, component);

    out.be("h5", null, "9", component);

    Locale_tag({
        renderBody: function(out) {
          out.t("Standby! We are setting up your institution");
        }
      }, out, __component, "10");

    out.ee();

    out.ee();
  }

  out.ee();

  out.ee();

  if (state.showPosterPlus) {
    PosterPlus_tag({
        width: 480,
        height: 480,
        maxSize: 240,
        accepts: "image/*",
        theme: state.user.settings.theme.mode
      }, out, __component, "11", [
      [
        "done",
        "onPushFiles",
        false
      ],
      [
        "cancelled",
        "onSelectFile",
        false,
        [
            false
          ]
      ]
    ]);
  }

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
